import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "roadsideAssistanceFilled"
const RoadsideAssistanceFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M6 17.625C7.035 17.625 7.875 18.465 7.875 19.5S7.035 21.375 6 21.375 4.125 20.535 4.125 19.5 4.965 17.625 6 17.625M17.625 17.625C18.66 17.625 19.5 18.465 19.5 19.5S18.66 21.375 17.625 21.375 15.75 20.535 15.75 19.5 16.59 17.625 17.625 17.625" />
          <path
            fillRule="evenodd"
            d="M16.5 8.437C17.632 8.437 18.668 9.077 19.174 10.09L20.322 12.387 21.82 13.586C22.13 13.833 22.312 14.21 22.312 14.61V17.25H21.376C21.065 17.25 20.813 17.502 20.813 17.812S21.064 18.375 21.375 18.375H22.313V19.125C22.313 19.85 21.725 20.437 21 20.437H20.077C20.188 20.147 20.25 19.83 20.25 19.5 20.25 18.05 19.075 16.875 17.625 16.875S15 18.05 15 19.5C15 19.83 15.062 20.146 15.173 20.437H8.453C8.562 20.147 8.624 19.83 8.624 19.5 8.625 18.05 7.45 16.875 6 16.875S3.375 18.05 3.375 19.5Q3.376 19.69 3.401 19.87L2.801 19.779C2.16 19.68 1.687 19.129 1.687 18.48V18.375H2.25C2.56 18.375 2.813 18.123 2.813 17.812S2.56 17.25 2.25 17.25H1.688V15.75C1.688 15.025 2.274 14.437 3 14.437H12.375C13.1 14.437 13.688 13.85 13.688 13.125V8.437zM17.063 11.25C17.063 11.768 17.483 12.187 18 12.187H18.965L18.168 10.593C17.938 10.135 17.536 9.8 17.063 9.65z"
            clipRule="evenodd"
          />
          <path d="M4.688 3.297C4.468 2.593 5.383 1.981 5.95 2.57L12.563 9.435V13.125C12.563 13.228 12.479 13.312 12.375 13.312H10.387L5.813 5.305V8.89Q6.088 8.968 6.334 9.12C6.65 9.315 6.908 9.593 7.08 9.923 7.25 10.253 7.33 10.624 7.309 10.995 7.287 11.368 7.165 11.726 6.957 12.034 6.747 12.341 6.459 12.587 6.122 12.743 5.785 12.902 5.412 12.964 5.042 12.927S4.316 12.752 4.018 12.53C3.72 12.308 3.488 12.009 3.345 11.665L4.385 11.235C4.448 11.39 4.554 11.525 4.69 11.626 4.826 11.727 4.987 11.79 5.155 11.807S5.493 11.796 5.646 11.724C5.8 11.653 5.931 11.541 6.026 11.401S6.176 11.098 6.186 10.93C6.196 10.76 6.16 10.592 6.082 10.443 6.004 10.293 5.887 10.166 5.742 10.077 5.6 9.988 5.435 9.94 5.266 9.937V9.936L5.25 9.937C4.94 9.937 4.688 9.685 4.688 9.375z" />
        </svg>
      }
    </span>
  )
}
export default RoadsideAssistanceFilledIcon
